module.exports = __webpack_public_path__ + "img/20.0d85dbd5.svg";